export const InvoicePositionTypes =  {
	TICKET: "Ticket"
}

export const InvoicePositionTypeEnums = {
	TICKET: "TICKET"
}

export interface InvoicePosition {
	uuid: string
	type: string
	name: string
	value: number
	vat: string
	info: string
	ticketHasBeenMadeAvailable: boolean;
	ticketUUID: string
}



// WEBPACK FOOTER //
// ./src/app/models/invoice-position.model.ts